// extracted by mini-css-extract-plugin
export default {"nav-menu":"styles_nav-menu__sETVL","menu-item":"styles_menu-item__9yj8r"};